import { BehaviorSubject } from 'rxjs';
import { OnInit, Renderer2 } from '@angular/core';
import {
  Directive,
  EventEmitter,
  ElementRef,
  Output,
  HostListener
} from "@angular/core";

/**
 * A directive that emit an event when element is hovered
 *
 * @export
 * @class HoveredDirective
 */
@Directive({
  selector: "[isHovered]",
  exportAs:'hovered'
})
export class HoveredDirective implements OnInit {
  /**
   * Output of the element that emit when element is hovered
   *
   * @memberof HoveredDirective
   */
  hovered = new BehaviorSubject(false);

  constructor(private element:ElementRef, private renderer:Renderer2) {

  }
  ngOnInit(): void {
    this.renderer.setStyle(this.element.nativeElement, 'cursor', 'pointer');
  }

  /**
   * A method to emit if hovered
   *
   * @param {*} event
   * @memberof HoveredDirective
   */
  @HostListener("mouseenter", ["$event"])
  onMouseEnter(event: any) {
    this.hovered.next(true);
  }

  /**
   * A method to emit if hovered
   *
   * @param {*} event
   * @memberof HoveredDirective
   */
  @HostListener("mouseleave", ["$event"])
  onMouseLeave(event: any) {
    this.hovered.next(false);
  }
}
